module.exports = {"id":"208448","name":"Emil Forsberg","rating":"82","photo":"./data/images/photos/4/208448.png","club":{"name":"RB Leipzig","logo":"./data/images/clubs/RBLeipzig.png"},"positions":["MOC","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EmilForsberg0.json
// module id = 1226
// module chunks = 0